<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1>{{'エントリー情報：編集' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button mat-raised-button color="primary" (click)="addEntry()" [disabled]="!entryFormGroup.valid || !applyForm.valid">
          <mat-icon>add</mat-icon>
          <span>{{'更新' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">

      <form class="form" [formGroup]="entryFormGroup">
        <div fxLayout="row" fxLayoutGap="20px">
          <div fxFlex="50%">
            <label>{{'イベント' | translate}}</label>
            <div *ngIf="!!event && !!event.names">
              {{ event.names[0].name }}
            </div>
          </div>
          <div fxFlex="50%">
            <label>{{'エントリー番号' | translate}}</label>
            <div *ngIf="!!entry && entry.entry_no">
              {{ entry.entry_no }}
            </div>
          </div>
        </div>
        <br>
        <div fxLayout="row" fxLayoutGap="20px">
          <div fxFlex="50%">
            <label>{{'登録日時' | translate}}</label>
            <div *ngIf="!!entry && entry.created">
              {{ entry.created | date: 'yyyy/MM/dd HH:mm:ss' }}
            </div>
          </div>
          <div fxFlex="50%">
            <label>{{'更新日時' | translate}}</label>
            <div *ngIf="!!entry && entry.updated">
              {{ entry.updated | date: 'yyyy/MM/dd HH:mm:ss' }}
            </div>
          </div>
        </div>
        <br>
       <div fxLayout="row" fxLayoutGap="20px">
          <div fxFlex="50%">
            <label>{{'メール送信状況' | translate}}</label>
            <div *ngFor="let mailSendStatus of mailSendStatuses">
              <div *ngIf="!!entry && entry.mail_send_status === mailSendStatus">
                {{ mailSendStatus | mailSendStatus }}
              </div>
            </div>
          </div>
        </div>
        <br>
        <br>

        <div fxLayout="row" fxLayoutGap="20px">
          {{'▼基本項目' | translate}}
        </div>
        <br>
        <div fxLayout="row" fxLayoutGap="20px">
          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'メールアドレス' | translate}}</mat-label>
            <input matInput placeholder="{{'メールアドレス' | translate}}" id="emailAddress" formControlName="emailAddress">
            <mat-error *ngIf="emailAddressControl.invalid">{{ getErrorMessageToEmailAddress() }}</mat-error>
          </mat-form-field>
          <mat-form-field *ngIf="event.is_visibled_mobile_phone_number" fxFlex="50%">
            <mat-label floatLabel="always">{{'携帯電話番号' | translate}}</mat-label>
            <input matInput placeholder="{{'携帯電話番号' | translate}}" id="mobilePhoneNumber" formControlName="mobilePhoneNumber">
          </mat-form-field>
        </div>
        <br>
        <div fxLayout="row" *ngIf="event.is_visibled_company_name" fxLayoutGap="20px">
          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'会社名' | translate}}</mat-label>
            <input matInput placeholder="{{'会社名' | translate}}" id="companyName" formControlName="companyName">
          </mat-form-field>
        </div>
        <br *ngIf="event.is_visibled_company_name">
        <div fxLayout="row" fxLayoutGap="20px">
          <mat-form-field *ngIf="event.is_visibled_department" fxFlex="100%">
            <mat-label floatLabel="always">{{'部署' | translate}}</mat-label>
            <input matInput placeholder="{{'部署' | translate}}" id="department" formControlName="department">
          </mat-form-field>
          <mat-form-field *ngIf="event.is_visibled_job_title" fxFlex="50%">
            <mat-label floatLabel="always">{{'役職' | translate}}</mat-label>
            <input matInput placeholder="{{'役職' | translate}}" id="jobTitle" formControlName="jobTitle">
          </mat-form-field>
        </div>
        <br *ngIf="event.is_visibled_department || event.is_visibled_job_title">
        <div fxLayout="row" fxLayoutGap="20px">
          <mat-form-field *ngIf="event.is_visibled_surname_chinese" fxFlex="50%">
            <mat-label floatLabel="always">{{'姓（漢字）' | translate}}</mat-label>
            <input matInput placeholder="{{'姓（漢字）' | translate}}" id="surnameChinese" formControlName="surnameChinese">
          </mat-form-field>
          <mat-form-field  *ngIf="event.is_visibled_name_chinese"fxFlex="50%">
            <mat-label floatLabel="always">{{'名（漢字）' | translate}}</mat-label>
            <input matInput placeholder="{{'名（漢字）' | translate}}" id="nameChinese" formControlName="nameChinese">
          </mat-form-field>
        </div>
        <br *ngIf="event.is_visibled_surname_chinese || event.is_visibled_name_chinese">
        <div fxLayout="row" fxLayoutGap="20px">
          <mat-form-field *ngIf="event.is_visibled_family_name" fxFlex="50%">
            <mat-label floatLabel="always">{{'姓（カナ）' | translate}}</mat-label>
            <input matInput placeholder="{{'姓（カナ）' | translate}}" id="familyName" formControlName="familyName">
            <mat-error *ngIf="familyNameControl.invalid">{{ getErrorMessageToFamilyName() }}</mat-error>
          </mat-form-field>
          <mat-form-field *ngIf="event.is_visibled_first_name" fxFlex="50%">
            <mat-label floatLabel="always">{{'名（カナ）' | translate}}</mat-label>
            <input matInput placeholder="{{'名（カナ）' | translate}}" id="firstName" formControlName="firstName">
            <mat-error *ngIf="familyNameControl.invalid">{{ getErrorMessageToFirstName() }}</mat-error>
          </mat-form-field>
        </div>
        <br *ngIf="event.is_visibled_family_name || event.is_visibled_first_name">
        <div fxLayout="row" fxLayoutGap="20px">
          <mat-form-field *ngIf="event.is_visibled_birthday" fxFlex="50%">
            <mat-label>{{'生年月日' | translate}}</mat-label>
            <input matInput [matDatepicker]="birthdayPicker" placeholder="{{'生年月日' | translate}}" formControlName="birthday" readonly>
            <button mat-button matSuffix aria-label="Clear" (click)="clearBirthday()">
              <mat-icon>close</mat-icon>
            </button>
            <mat-datepicker-toggle matSuffix [for]="$any(birthdayPicker)"></mat-datepicker-toggle>
            <mat-datepicker #birthdayPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field *ngIf="event.is_visibled_gender" fxFlex="50%">
            <mat-label>{{'性別' | translate}}</mat-label>
            <mat-select placeholder="{{'性別' | translate}}" id="gender" formControlName="gender">
              <mat-option *ngFor="let gender of genders" [value]="gender">{{ gender | gender }}</mat-option>
            </mat-select>
            <mat-error *ngIf="genderControl.invalid">{{ getErrorMessageToGender() }}</mat-error>
          </mat-form-field>
        </div>
        <br *ngIf="event.is_visibled_birthday || event.is_visibled_gender">
        <div *ngIf="event.is_visibled_address" fxLayout="row" fxLayoutGap="20px">
          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'郵便番号' | translate}}</mat-label>
            <input matInput placeholder="{{'郵便番号' | translate}}" id="postalCode" formControlName="postalCode">
          </mat-form-field>
        </div>
        <br>
        <div *ngIf="event.is_visibled_address" fxLayout="row" fxLayoutGap="20px">
          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'都道府県' | translate}}</mat-label>
            <input matInput placeholder="{{'都道府県' | translate}}" id="prefecture" formControlName="prefecture">
          </mat-form-field>
          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'市区町村' | translate}}</mat-label>
            <input matInput placeholder="{{'市区町村' | translate}}" id="municipalities" formControlName="municipalities">
          </mat-form-field>
        </div>
        <br *ngIf="event.is_visibled_address">
        <div *ngIf="event.is_visibled_address" fxLayout="row" fxLayoutGap="20px">
          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'町名番地' | translate}}</mat-label>
            <input matInput placeholder="{{'町名番地' | translate}}" id="streetAddress" formControlName="streetAddress">
          </mat-form-field>
          <mat-form-field fxFlex="50%">
            <mat-label floatLabel="always">{{'建物名・号室' | translate}}</mat-label>
            <input matInput placeholder="{{'建物名・号室' | translate}}" id="nameAndNumberBuilding" formControlName="nameAndNumberBuilding">
          </mat-form-field>
        </div>
        <br *ngIf="event.is_visibled_address">
      </form>

      <div *ngIf="questions && questions.length > 0 && entry">
        {{'▼カスタム項目' | translate}}
        <br>
        <br>
        <form [formGroup]="applyForm">
          <div formArrayName="options">
            <div *ngFor="let option of options.controls; let i = index">
              <!-- string -->
              <div fxLayout="row" fxLayoutGap="20px">
              <mat-form-field *ngIf="questions[i].question_type == 'string'" [formGroupName]="i" fxFlex="100%">
                <mat-label floatLabel="always">{{questions[i].question_names[0].name}}</mat-label>
                <input matInput type="text" placeholder="{{questions[i].question_names[0].name}}" id="value" formControlName="value">
              </mat-form-field>
              <!-- text-area -->
              <mat-form-field *ngIf="questions[i].question_type == 'text-area'" [formGroupName]="i" fxFlex="100%">
                <mat-label floatLabel="always">{{questions[i].question_names[0].name}}</mat-label>
                <textarea matInput type="text" placeholder="{{questions[i].question_names[0].name}}" rows="5" formControlName="value" class="!resize-none"></textarea>
              </mat-form-field>
              <!-- number -->
              <mat-form-field *ngIf="questions[i].question_type == 'number'" [formGroupName]="i" fxFlex="100%">
                <mat-label floatLabel="always">{{questions[i].question_names[0].name}}</mat-label>
                <input matInput type="number" placeholder="{{questions[i].question_names[0].name}}" formControlName="value">
              </mat-form-field>
              <!-- select -->
              <ng-container *ngIf="questions[i].question_type == 'select'" [formGroupName]="i">
                <mat-form-field fxFlex="100%">
                  <mat-label floatLabel="always">{{questions[i].question_names[0].name}}</mat-label>
                  <mat-select placeholder="{{questions[i].question_names[0].name}}" formControlName="value" (selectionChange)="selectChange($event, i)">
                    <mat-option *ngIf="entry" value=""></mat-option>
                    <mat-option *ngFor="let item of questions[i].question_select_items" [value]="item.value">{{item.items[0].item}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
              <!-- checkbox -->
              <div *ngIf="questions[i].question_type == 'checkbox'" [formGroupName]="i">
                <label>{{questions[i].question_names[0].name}}
                  <ng-container *ngIf="questions[i].question_check.includes('01')">
                    <span class="required-star">★</span>
                  </ng-container>
                </label>
                <div *ngFor="let item of questions[i].question_select_items; let j = index">
                  <mat-checkbox [checked]="option.value.value[j].value.selected" (change)="checkToggle($event, i, j)">
                    {{item.items[0].item}}
                  </mat-checkbox>
                </div>
                <br>
              </div>
              <!-- radio -->
              <div *ngIf="questions[i].question_type == 'radio'" [formGroupName]="i">
                <label>{{questions[i].question_names[0].name}}
                  <ng-container *ngIf="questions[i].question_check.includes('01')">
                    <span class="required-star">★</span>
                  </ng-container>
                </label>
                <mat-radio-group>
                  <div *ngFor="let item of questions[i].question_select_items; let j = index">
                    <mat-radio-button [value]="option.value.value[j].value.value" [checked]="option.value.value[j].value.selected" (change)="radioChange($event, i)" class="reservation-radio-button">
                      {{item.items[0].item}}
                    </mat-radio-button>
                  </div>
                </mat-radio-group>
                <br>
              </div>
              <br>
            </div>
          </div>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>

